import { cn } from "src/common/utils";

const AppDynamicsIcon = ({ className }: { className?: string }) => (
  <div className={cn(className, "bg-white rounded-sm p-1")}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width="100%"
      height="100%"
    >
      <g transform="matrix(5.3440923,0,0,5.3440923,-72.14965,-118.02575)">
        <path
          d="m 18.971019,32.853173 -3.50302,-7.299396 c -0.845556,0.776532 -1.3805,1.880932 -1.3805,3.123382 0,2.329595 1.898188,4.227783 4.227782,4.227783 0.224332,0 0.431407,-0.01726 0.655738,-0.05177"
          fill="#232736"
        />
        <path
          d="m 17.53875,24.518402 c 0.258844,-0.05177 0.517688,-0.06902 0.776531,-0.06902 2.329595,0 4.227783,1.898188 4.227783,4.227782 0,1.276963 -0.569456,2.433132 -1.484038,3.209664 l 1.035375,2.174288 c 1.691113,-1.190682 2.795514,-3.157895 2.795514,-5.383952 0.01726,-3.64107 -2.933564,-6.591889 -6.574634,-6.591889 -0.621225,0 -1.24245,0.08628 -1.811906,0.258844 z"
          fill="#232736"
        />
      </g>
    </svg>
  </div>
);

export default AppDynamicsIcon;